import { useContext } from 'react';
import { PortalSettingsContext } from 'shared/providers/portal-settings.provider';

export const useOurCompany = () => {
  const settings = useContext(PortalSettingsContext);
  return settings.ourCompanyId;
};